const artGallery = function() {
    const defaults = {
        selectors: {
            container: ".artGallery",
            teaser: ".teaserTile",
            item: ".artGallery-item",
            slide: ".imageSlider-item",
        }
    };

    function init() {

        const containers = document.querySelectorAll(defaults.selectors.container);

        for (let i = 0; i < containers.length; i++) {
            new ArtGallery(containers[i]);
        }

    }

    const ArtGallery = function(container) {

        this.container = container;

            // Get items

        this.items = this.getItems(this);

            // Get teasers

        this.teasers = this.getTeasers(this);


    }

    ArtGallery.prototype.getItems = function() {

        let items = [];

        const elements = this.container.querySelectorAll(defaults.selectors.item);

        for (let i = 0; i < elements.length; i++) {

            const element = elements[i],
                  item = new Item(element, this);

            items.push(item);

        }

        return items;

    }

    ArtGallery.prototype.showItem = function(index) {

        if (typeof this.items[index] === "undefined") {
            return;
        }

        this.items[index].show();

    }

    ArtGallery.prototype.getSlidesCount = function(index) {

        let count = 0;

        if (typeof this.items.length === "undefined" || typeof this.items[index] === "undefined") {
            return count;
        }

        const item = this.items[index],
              slides = this.items[index].container.querySelectorAll(defaults.selectors.slide);

        count = slides.length;

        return count;

    }

    ArtGallery.prototype.getTeasers = function() {

        let teasers = [];

        const elements = this.container.querySelectorAll(defaults.selectors.teaser);

        for (let index = 0; index < elements.length; index++) {

            const element = elements[index],
                  teaser = new Teaser(element, index, this);

            teasers.push(teaser);

        }

        return teasers;

    }

    const Item = function(container, parent) {

        this.container = container;
        this.parent = parent;

    }

    Item.prototype.getContent = function() {

        let content = "";

        if (this.container.children.length === 0) {
            console.warn("artGallery: No content node found!");
            return content;
        }

        if (this.container.children.length > 1) {
            console.warn("artGallery: There are multiple content nodes. Only the first will be used!");
        }

        return this.container.children[0];

    }

    Item.prototype.show = function() {

        const self = this;

        if (typeof this.content === "undefined") {
            this.content = this.getContent();
        }

            // Reset all slideshows and show overlay

        let events = [];

        events.push(
            new CustomEvent(
                "imageSlider:reset"
            )
        );

        events.push(
            new CustomEvent(
                "fullscreenOverlay:show",
                {
                    detail: {
                        content: self.content
                    }
                }
            )
        );

            // Dispatch events

        for (let i = 0; i < events.length; i++) {
            document.dispatchEvent(events[i]);
        }

            // Focus slideshow

        const focus = new CustomEvent(
            "imageSlider:focus"
        );

        this.content.dispatchEvent(focus);

    }

    const Teaser = function(container, index, parent) {

        this.container = container;
        this.index = index;
        this.parent = parent;

        const slides_count = this.parent.getSlidesCount(index);

        if (slides_count === 0) {
            return;
        }

        this.container.classList.add("is-active");

        this.container.onclick = () => {
            this.parent.showItem(this.index);
        }

    }

    return {
        init: init
    }

}();

artGallery.init();
